import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { ReportStudioPageDesignOption } from '@/modules/ta/reportstudio/models/ReportStudioPageDesignOption';

export class ReportStudioPageMetadata extends BaseModel {
  /**
   * @type {ReportStudioPageDesignOption}
   */
  design_options;

  /**
   * @type {string}
   */
  assignment_type;

  /**
   * @type {array}
   */
  assigned_values;

  /**
   * @type {boolean}
   */
  isHidden;

  constructor(model = {}) {
    super();

    this.design_options = new ReportStudioPageDesignOption(model.design_options);
    this.assignment_type = model.assignment_type;
    this.assigned_values = model.assigned_values;
    this.isHidden = model.isHidden;
  }
}
